var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00911 2.04751L9.03578 4.10084C9.17578 4.38668 9.54911 4.66084 9.86411 4.71334L11.7249 5.02251C12.9149 5.22084 13.1949 6.08418 12.3374 6.93584L10.8908 8.38251C10.6458 8.62751 10.5116 9.10001 10.5874 9.43834L11.0016 11.2292C11.3283 12.6467 10.5758 13.195 9.32161 12.4542L7.57745 11.4217C7.26245 11.235 6.74328 11.235 6.42245 11.4217L4.67828 12.4542C3.42995 13.195 2.67161 12.6408 2.99828 11.2292L3.41245 9.43834C3.48828 9.10001 3.35411 8.62751 3.10911 8.38251L1.66245 6.93584C0.81078 6.08418 1.08495 5.22084 2.27495 5.02251L4.13578 4.71334C4.44495 4.66084 4.81828 4.38668 4.95828 4.10084L5.98495 2.04751C6.54495 0.933342 7.45495 0.933342 8.00911 2.04751Z",
    fill: "#FBAA19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d0000d376c8c16961e1658e8a88b68b6.svg";
export { ForwardRef as ReactComponent };